import {
    LENDER_AGREEMENT,
    LENDER_AGREEMENT_SUCCESS,
    LENDER_AGREEMENT_ERROR,
    UPDATE_AGREEMENT_SUCCESS,
    UPDATE_AGREEMENT,
    UPDATE_AGREEMENT_ERROR
} from '../actionType'

export const getLenderAgreementReques= () => ({
    type: LENDER_AGREEMENT
});

export const getLenderAgreementSuccess = (data:any) => ({
    type: LENDER_AGREEMENT_SUCCESS,
    payload: data
});

export const getLenderAgreementError = (error:any) => ({
    type: LENDER_AGREEMENT_ERROR,
    payload:error
});

export const updateAgreementRequest = () => ({
    type: UPDATE_AGREEMENT
});
export const updateAgreementSuccess = (data:any) => ({
    type: UPDATE_AGREEMENT_SUCCESS,
    payload:data
});
export const updateAgreementError = (error:any) => ({
    type:UPDATE_AGREEMENT_ERROR,
    payload: error
})